import { type FunctionComponent, type PropsWithChildren, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { JUMB_TAB_ANCHOR_PREFIX } from '../../constants/common-component.constants';
import { useRouterLocation } from '../../hooks/routing/location.hook';
import { scrollToElement } from '../../utils/dom/dom.utils';

const ScrollPositionHandler: FunctionComponent = () => {
	const { pathname, hash } = useRouterLocation();

	// scroll to element on hash change
	useEffect(() => {
		if (hash) {
			// An exception for jump tabs
			if (!hash.startsWith(`#${JUMB_TAB_ANCHOR_PREFIX}`)) {
				scrollToElement(hash);
			}
		}
	}, [hash]);

	// scroll to top on route change
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};

/**
 * The purpose of this component is to generate a router that is in charge of keeping track of the history
 * of the site. Mainly for analytical purposes.
 */
export const BuildRouter: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<BrowserRouter>
		<ScrollPositionHandler />
		{children}
	</BrowserRouter>
);
